export default __webpack_public_path__ + "static/media/success-dialog.3c8d0f49.svg";